import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { cn } from "@/lib/utils";

// Многострочное поле по макету (text-field «Отзыв»): заливка #1F1F1F 3 %, r20,
// pad 12/16, Manrope 16/21 w500, плейсхолдер #1F1F1F 48 %. Фокус — чёрная
// обводка 1px (A-03, A-06), ошибка — #E1574F.
function Textarea(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("flex field-sizing-content min-h-16 w-full rounded-[20px] border border-transparent bg-ds-field px-4 py-3 text-[16px] leading-[21px] font-medium text-ds-primary transition-[border-color] outline-none placeholder:text-ds-placeholder focus-visible:border-ds-focus disabled:cursor-not-allowed disabled:opacity-60 aria-invalid:border-ds-error", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <textarea data-slot="textarea" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export { Textarea };